import config from 'src/config';

import { httpClient } from 'src/utils/axios';
import {
  VotacaoItem,
  Pergunta,
  Resposta,
  ResultadoPergunta,
  Entrada,
  Assinaturas,
  Procuracoes,
  PreLogin
} from 'src/app/types/votacao';

export function getVotacao(token: string) {
  return httpClient<VotacaoItem>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${token}`,
    withCredentials: true
  });
}

export function getPerguntas(codigoVotacao: number) {
  return httpClient<Pergunta[]>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/perguntas`,
    withCredentials: true
  });
}

export function getPergunta(codigoVotacao: number, codigoPergunta: number) {
  return httpClient<Pergunta[]>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/perguntas/${codigoPergunta}`,
    withCredentials: true
  });
}

export function postResposta(params: Resposta) {
  return httpClient<null>({
    method: 'POST',
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${params.codigoVotacao}/respostas`,
    data: params,
    withCredentials: true
  });
}

export function putResposta(params: Resposta) {
  return httpClient<null>({
    method: 'PUT',
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${params.codigoVotacao}/respostas`,
    data: params,
    withCredentials: true
  });
}

export function getResultadoPergunta(
  codigoVotacao: number,
  codigoPergunta: number
) {
  return httpClient<ResultadoPergunta>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/perguntas/${codigoPergunta}/resultado`,
    withCredentials: true
  });
}

// novos endpoints

export function getEntrada(codigoVotacao: number) {
  return httpClient<Entrada>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/entrada`,
    withCredentials: true
  });
}

export function postAssinaturas(params: Assinaturas) {
  return httpClient<null>({
    method: 'POST',
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${params.votacao}/assinaturas`,
    data: params,
    withCredentials: true
  });
}

export function getProcuracoes(codigoVotacao: number) {
  return httpClient<Procuracoes[]>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/procuracoes`,
    withCredentials: true
  });
}

// export function putProcuracoes(params: Procuracoes) {
//   return httpClient<null>({
//     method: 'PUT',
//     url: `${config.backend.apiAssembleias}/api/v1/votacoes/${params.votacao}/procuracoes`,
//     withCredentials: true
//   });
// }

export function postProcuracoes(params: Procuracoes) {
  return httpClient<null>({
    method: 'POST',
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${params.votacao}/procuracoes`,
    data: params,
    withCredentials: true
  });
}

export function getProcuracoesByUnidade(
  codigoVotacao: number,
  codigoUnidade: number
) {
  return httpClient<Procuracoes[]>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/procuracoes/${codigoUnidade}`,
    withCredentials: true
  });
}

export function deleteProcuracoesByCod(
  codigoVotacao: number,
  codigoProcuracao: number
) {
  return httpClient<null>({
    method: 'DELETE',
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${codigoVotacao}/procuracoes/${codigoProcuracao}`,
    withCredentials: true
  });
}

export function getPreLogin(token: string) {
  return httpClient<PreLogin>({
    url: `${config.backend.apiAssembleias}/api/v1/votacoes/${token}/prelogin`
  });
}
